import React, { useState, useEffect } from 'react';

// Componente para validación de seguridad en tiempo real
const SecurityValidator = ({ value, fieldName, onValidationChange }) => {
  const [errors, setErrors] = useState([]);
  const [isValidating, setIsValidating] = useState(false);

  useEffect(() => {
    if (!value || typeof value !== 'string') {
      setErrors([]);
      onValidationChange?.(true, []);
      return;
    }

    setIsValidating(true);
    
    // Validar solo patrones realmente peligrosos
    const validationErrors = [];
    
    const dangerousPatterns = [
      { pattern: /<script[^>]*>/gi, message: 'No se permiten etiquetas script' },
      { pattern: /javascript:/gi, message: 'No se permiten enlaces javascript' },
      { pattern: /on\w+\s*=/gi, message: 'No se permiten event handlers' },
      { pattern: /<iframe[^>]*>/gi, message: 'No se permiten iframes' },
      { pattern: /<object[^>]*>/gi, message: 'No se permiten objetos embebidos' },
      { pattern: /<embed[^>]*>/gi, message: 'No se permiten embebidos' },
      { pattern: /expression\s*\(/gi, message: 'No se permiten expresiones CSS' },
      { pattern: /eval\s*\(/gi, message: 'No se permite código eval' },
      { pattern: /import\s*\(/gi, message: 'No se permiten imports dinámicos' }
    ];

    for (const { pattern, message } of dangerousPatterns) {
      if (pattern.test(value)) {
        validationErrors.push(message);
        break; // Solo reportar el primer error encontrado
      }
    }

    setErrors(validationErrors);
    onValidationChange?.(validationErrors.length === 0, validationErrors);
    setIsValidating(false);
  }, [value, fieldName, onValidationChange]);

  if (errors.length === 0) {
    return null;
  }

  return (
    <div className="security-validation-error mt-1">
      <small className="text-danger">
        <i className="fas fa-exclamation-triangle me-1"></i>
        {errors[0]}
      </small>
    </div>
  );
};

export default SecurityValidator;

